import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

var youtubeRegx = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
var vimeoRegx = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\\-]+)?/i;
var isNumber = function isNumber(arg) {
  return !isNaN(parseFloat(arg)) && isFinite(arg);
};
var isObject = function isObject(arg) {
  return Object.prototype.toString.call(arg) === '[object Object]';
};
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
function cssUnit(val) {
  var regx = /^\d+(px|em|%|vw|vh|rem)?$/;

  if (regx.test(val)) {
    return isNaN(val) ? val : val + 'px';
  }

  return '';
}
var randomStr = function randomStr() {
  return Math.floor(Math.random() * Date.now()).toString(36);
};
function isMp4(url) {
  if (url && typeof url === 'string') {
    var suffix = fileSuffix(url);
    return ['mp4', 'mov', 'webm', 'ogg', 'avi'].includes(suffix);
  }

  return false;
}
function isYoutube(url) {
  if (url && typeof url === 'string') {
    return youtubeRegx.test(url);
  }

  return false;
}
function isVimeo(url) {
  if (url && typeof url === 'string') {
    return vimeoRegx.test(url);
  }

  return false;
}
function isVideo(url) {
  return isMp4(url) || isYoutube(url) || isVimeo(url);
}
function getYoutubeID(url) {
  if (url && typeof url === 'string') {
    var result = url.match(youtubeRegx);
    return result && result.length > 1 ? result[1] : null;
  }

  return null;
}
function getYoutubeUrl(url) {
  var ytId = getYoutubeID(url);

  if (ytId) {
    return "https://www.youtube.com/embed/".concat(ytId, "?autoplay=0&mute=1&controls=1&rel=0");
  }

  return null;
}
function getVimeoID(url) {
  if (url && typeof url === 'string') {
    var result = url.match(vimeoRegx);
    return result && result.length > 1 ? result[1] : null;
  }

  return null;
}
function getVimeoUrl(url) {
  var vimeoID = getVimeoID(url);

  if (vimeoID) {
    return "https://player.vimeo.com/video/".concat(vimeoID, "?autoplay=0&muted=1&byline=0&portrait=0&fullscreen=1");
  }

  return null;
}
/**
 * 获取文件类型
 * @param {*} url 文件url
 * @param {*} ext 文件类型
 * @returns
 */

function getMediaType(_ref) {
  var src = _ref.src,
      mediaType = _ref.mediaType;

  if (['image', 'video', 'webVideo', 'iframe'].includes(mediaType)) {
    return mediaType;
  } else {
    if (isYoutube(src) || isVimeo(src)) {
      return 'webVideo';
    }

    var type = mediaType || fileSuffix(src);

    if (['mp4', 'mov', 'webm', 'ogg', 'avi'].includes(type)) {
      return 'video';
    } else if (['pdf'].includes(type)) {
      return 'iframe';
    } else {
      return 'image';
    }
  }
}
function getMediaThumb(_ref2) {
  var src = _ref2.src,
      thumb = _ref2.thumb,
      mediaType = _ref2.mediaType;
  if (thumb) return thumb;
  var defaultPic = '';
  var type = getMediaType({
    src: src,
    mediaType: mediaType
  });
  if (type === 'image') return src;

  if (type === 'video' || type === 'webVideo') {
    var ytId = getYoutubeID(src);

    if (ytId) {
      return 'https://img.youtube.com/vi/' + ytId + '/mqdefault.jpg';
    }

    var vimeoId = getVimeoID(src);

    if (vimeoId) {
      // https://i.vimeocdn.com/video/17892962_320.jpg
      return "https://vumbnail.com/".concat(vimeoId, ".jpg");
    }

    if (src.includes('.aliyuncs.com')) {
      return src.split('?')[0] + '?x-oss-process=video/snapshot,t_1000,f_jpg,m_fast';
    }
  }

  return defaultPic;
}
function getVideoUrl(url) {
  var youtubeUrl = getYoutubeUrl(url);
  if (youtubeUrl) return youtubeUrl;
  var vimeoUrl = getVimeoUrl(url);
  if (vimeoUrl) return vimeoUrl;
  return url;
}
/**
 * 获取文件后缀
 * @param {*} fileSrc 文件url
 * @returns {string}
 */

function fileSuffix(fileSrc) {
  if (typeof fileSrc !== 'string') return '';
  var _path = fileSrc.split('?')[0];
  return _path.includes('.') ? _path.split('.').pop().toLocaleLowerCase() : '';
}
/**
 * 视频 sourceType
 * @param {string} src 文件地址
 * @param {object} param1 扩展参数
 * @returns {string}
 */

function videoSourceType(src, _ref3) {
  var ext = _ref3.ext;

  var _ext = ext || fileSuffix(src);

  return _ext ? "video/".concat(_ext) : '';
}
function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}
function fullScreenMode() {
  var el = document.documentElement;

  if (el.requestFullscreen) {
    el.requestFullscreen();
    return true;
  } else if (el.webkitRequestFullScreen) {
    el.webkitRequestFullScreen();
    return true;
  } else if (el.mozRequestFullScreen) {
    el.mozRequestFullScreen();
    return true;
  } else if (el.msRequestFullscreen) {
    el.msRequestFullscreen();
    return true;
  }

  console.warn('Sorry, your browser does not support fullscreen mode!');
  return false;
}
function addFullscreenListener(listener) {
  document.addEventListener('fullscreenchange', listener);
  document.addEventListener('webkitfullscreenchange', listener);
  document.addEventListener('mozfullscreenchange', listener);
  document.addEventListener('msfullscreenchange', listener);
}
function removeFullscreenListener(listener) {
  document.removeEventListener('fullscreenchange', listener);
  document.removeEventListener('webkitfullscreenchange', listener);
  document.removeEventListener('mozfullscreenchange', listener);
  document.removeEventListener('msfullscreenchange', listener);
}
/**
 * 匹配所有元素，同 Element.matches
 * @param {*} target 对比目标元素
 * @param {*} selector 选择器
 * @param {*} wrapper 选择器范围
 * @returns
 */

function matchesDom(target, selector, wrapper) {
  if (!(target instanceof Element)) return false;

  if (!(wrapper instanceof Element)) {
    wrapper = document;
  }

  var selectorArr = Array.isArray(selector) ? selector : selector.split(',');
  var matches = selectorArr.reduce(function (a, c) {
    var els = wrapper.querySelectorAll(c);
    a.push.apply(a, _toConsumableArray(els));
    return a;
  }, []);

  for (var i = 0, len = matches.length; i < len; i++) {
    if (matches[i] === target) return true;
  }

  return false;
}
/**
 * 加载image
 * @param {string} src image url
 * @param {function} callback callback
 * @returns {Image}
 */

function loadImage(path, callback) {
  var img = new Image();

  img.onerror = function (error) {
    callback && callback(error);
    img.onerror = img = null;
  };

  img.onload = function () {
    callback && callback(null, img);
    img.onload = img = null;
  };

  img.src = path;

  if (img.complete) {
    callback && callback(null, img);
    img.onerror = img.onload = img = null;
  }

  return img;
}
/**
 * 加载video
 * @param {string} src video url
 * @param {function} callback callback
 * @returns {video}
 */

function loadVideo(src, callback) {
  var video = document.createElement('video');

  video.onerror = function (error) {
    callback && callback(error);
    video.onerror = video = null;
  };

  video.onloadedmetadata = function () {
    // width: video.videoWidth, height: video.videoHeight
    callback && callback(null, video);
    video.onloadeddata = video = null;
  };

  video.src = src;
  return video;
}
/**
 * 加载iframe
 * @param {string} src iframe url
 * @param {function} callback callback
 * @returns {iframe}
 */

function loadIframe(src, callback) {
  var iframe = document.createElement('iframe');
  var iframeId = "iframe-".concat(randomStr());

  iframe.onerror = function (error) {
    callback && callback(error);
    iframe.onerror = iframe = null;
  };

  iframe.onload = function () {
    callback && callback(null, iframe);
    iframe.onload = iframe = null;
  };

  iframe.destroy = function () {
    var getIframe = document.getElementById(iframeId);

    if (iframe && getIframe) {
      if (getIframe === iframe) {
        document.body.removeChild(iframe);
      } // iframe.destroy = null

    }
  };

  iframe.setAttribute('style', 'width:0;height:0;position:absolute;left:-99999em');
  iframe.setAttribute('src', src);
  iframe.setAttribute('id', iframeId);
  document.body.appendChild(iframe);
  return iframe;
}

/**
 * 设置为自动播放地址
 * @param {*} url url
 * @returns {string}
 */

function setAutoplay(url) {
  var urlArr = url.split('?');

  if (urlArr.length > 1) {
    var urlParams = urlArr[1].split('&').reduce(function (acc, item) {
      var itemArr = item.split('=');
      acc[itemArr[0]] = itemArr[1];
      return acc;
    }, {});
    if (urlParams.autoplay !== '1') urlParams.autoplay = 1;
    return urlArr[0] + '?' + Object.keys(urlParams).map(function (key) {
      return "".concat(key, "=").concat(urlParams[key]);
    }).join('&');
  } else {
    return url + '?autoplay=1';
  }
}

function isAutoplay(arg) {
  return parseInt(arg) === 1 || arg === 'true' || arg === true;
}

function loadMedia(type) {
  var methods = {
    image: loadImage,
    video: loadVideo,
    webVideo: loadIframe,
    iframe: loadIframe
  };
  return methods[type];
}

var LoadMedia = {
  inserted: function inserted(el, _ref, vnode) {
    var arg = _ref.arg;
    var ctx = vnode.context;
    var _el$dataset = el.dataset,
        src = _el$dataset.src,
        autoplay = _el$dataset.autoplay;
    var _src = src;
    var loadMethod = loadMedia(arg);

    if (arg && loadMethod) {
      // loading时隐藏元素
      el.style.visibility = 'hidden'; // reset rotate 此处是loading状态，重置rotate最佳

      ctx.resetRotate(); // set autoplay

      if (isAutoplay(autoplay) && (arg === 'video' || arg === 'webVideo')) {
        if (el.tagName === 'VIDEO') {
          el.muted = true;
          el.autoplay = true;
        } else {
          _src = setAutoplay(src);
        }
      } // $el 用于销毁load时插入的DOM
      // load file


      var $el = loadMethod(_src, function () {
        // loading后显示元素
        el.style.visibility = 'visible';

        try {
          // 设置 loading = false
          ctx.changeLoading(false); // laoding完成回调

          /* if (el) {
            ctx.mediaLoaded(err, {
              width: result.width || result.videoWidth,
              height: result.height || result.videoHeight,
              type: arg,
              file: result
            })
          } */

          el.src = _src;
          if ($el && $el.destroy) $el.destroy();
        } catch (error) {
          console.error(error);
        }
      });
      el.__vm_el__ = $el;
    }
  },
  unbind: function unbind(el) {
    // 销毁插入的元素
    var $el = el.__vm_el__;
    if ($el && $el.destroy) $el.destroy();
  }
};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  name: 'Icon',
  props: {
    name: String
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24"
    }
  }, [_vm.name === "close" ? [_c("path", {
    attrs: {
      d: "M20 20L4 4m16 0L4 20",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "bevel"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "arrow-left" ? [_c("path", {
    attrs: {
      d: "M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "arrow-right" ? [_c("path", {
    attrs: {
      d: "M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "grid" ? [_c("path", {
    attrs: {
      d: "M14 10v4h-4v-4h4zm2 0h5v4h-5v-4zm-2 11h-4v-5h4v5zm2 0v-5h5v4a1 1 0 0 1-1 1h-4zM14 3v5h-4V3h4zm2 0h4a1 1 0 0 1 1 1v4h-5V3zm-8 7v4H3v-4h5zm0 11H4a1 1 0 0 1-1-1v-4h5v5zM8 3v5H3V4a1 1 0 0 1 1-1h4z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "play" ? [_c("path", {
    attrs: {
      d: "M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "pause" ? [_c("path", {
    attrs: {
      d: "M6 5h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "fullscreen" ? [_c("path", {
    attrs: {
      d: "M20 3h2v6h-2V5h-4V3h4zM4 3h4v2H4v4H2V3h2zm16 16v-4h2v6h-6v-2h4zM4 19h4v2H2v-6h2v4z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "offscreen" ? [_c("path", {
    attrs: {
      d: "M18 7h4v2h-6V3h2v4zM8 9H2V7h4V3h2v6zm10 8v4h-2v-6h6v2h-4zM8 15v6H6v-4H2v-2h6z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "rotate-left" ? [_c("path", {
    attrs: {
      d: "M13.414 6l1.829 1.828-1.415 1.415L9.586 5 13.828.757l1.415 1.415L13.414 4H16a5 5 0 0 1 5 5v4h-2V9a3 3 0 0 0-3-3h-2.586zM15 11v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zm-2 1H5v8h8v-8z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "rotate-right" ? [_c("path", {
    attrs: {
      d: "M10.586 4L8.757 2.172 10.172.757 14.414 5l-4.242 4.243-1.415-1.415L10.586 6H8a3 3 0 0 0-3 3v4H3V9a5 5 0 0 1 5-5h2.586zM9 11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11zm2 1v8h8v-8h-8z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "zoom-in" ? [_c("path", {
    attrs: {
      d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15zM10 10V7h2v3h3v2h-3v3h-2v-3H7v-2h3z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "zoom-out" ? [_c("path", {
    attrs: {
      d: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15zM7 10h8v2H7v-2z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "plus" ? [_c("path", {
    attrs: {
      d: "M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "minus" ? [_c("path", {
    attrs: {
      d: "M5 11h14v2H5z",
      fill: "currentColor"
    }
  })] : _vm._e(), _vm._v(" "), _vm.name === "download" ? [_c("path", {
    attrs: {
      d: "M13 10h5l-6 6-6-6h5V3h2v7zm-9 9h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7z",
      fill: "currentColor"
    }
  })] : _vm._e()], 2);
};

var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
var script = {
  name: 'Lightbox',
  components: {
    Icon: __vue_component__$1
  },
  directives: {
    load: LoadMedia
  },
  props: {
    index: Number,
    items: {
      type: Array,
      required: true
    },
    container: {
      type: [Element, String],
      default: function _default() {
        return document.body;
      }
    },
    theme: {
      type: String,
      default: 'dark'
    },
    customClass: String,
    highColor: {
      type: String,
      default: '#fa4242'
    },
    zIndex: {
      type: Number,
      default: 99999
    },
    overlayColor: String,
    // 导航器
    navigator: {
      type: Boolean,
      default: true
    },
    toolbar: Array,
    loop: {
      type: Boolean,
      default: true
    },
    slideDuration: {
      type: Number,
      default: 3500
    },
    showGallery: Boolean,
    galleryPosition: {
      type: String,
      validtor: function validtor(val) {
        return ['right', 'bottom'].includes(val);
      }
    },
    video: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 0,
          // width, height, maxWidth, maxHeight
          ratio: 1.77778 // 16 : 9

        };
      }
    },
    iframe: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableWheelEvent: Boolean,
    enableScrollLock: {
      type: Boolean,
      default: true
    },
    // 点击关闭
    clickOutsideHide: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      // swipe data
      initialMouseX: 0,
      initialMouseY: 0,
      endMouseX: 0,
      endMouseY: 0,
      swipeType: null,
      IsSwipping: false,
      isDraggingSwipe: false,
      // use for mouse wheel
      prevTime: 0,
      // styles data
      isVisible: false,
      imgIndex: this.index,
      paddingBottom: false,
      itemLoading: false,
      showThumbs: this.showGallery,
      isFullScreenMode: false,
      // aspect ratio videos
      aspectRatio: {
        width: 'auto',
        height: 'auto'
      },
      // props to bind styles
      buttonsVisible: true,
      scale: 1,
      top: 0,
      left: 0,
      lastX: 0,
      lastY: 0,
      isDraging: false,
      canZoom: true,
      isZooming: false,
      zoomBarSize: 0,
      imgTransform: '',
      // rotate
      viewTransition: 'all .3s ease',
      viewRotate: 0,
      // slideshow playing data
      isPlayingSlideShow: false,
      intervalProgress: null,
      loopData: this.loop,
      stylesInterval: {
        'display': 'block'
      },
      $parentEl: null,
      // id
      viewerId: 'viewer-' + randomStr()
    };
  },
  computed: {
    // get item
    currentItem: function currentItem() {
      var index = this.imgIndex;
      var item = this.$_getItem(index);

      if (item) {
        item.mediaType = getMediaType(item);

        if (['webVideo', 'video'].includes(item.mediaType)) {
          item.src = getVideoUrl(item.src);
        }

        return item;
      }

      return null;
    },
    videoSourceType: function videoSourceType$1() {
      if (this.currentItem) {
        var _this$currentItem = this.currentItem,
            src = _this$currentItem.src,
            ext = _this$currentItem.ext;
        return videoSourceType(src, {
          ext: ext
        });
      }

      return '';
    },
    // Images wrapper styles to use drag and zoom
    mediaWrapStyle: function mediaWrapStyle() {
      var styleObj = {
        position: 'absolute',
        top: '50%',
        left: '50%'
      }; // transition

      if (this.viewTransition) styleObj['transition'] = this.viewTransition; // transform

      var transform = 'translate3d(-50%, -50%, 0px) scale3d(1, 1, 1)'; // process image

      if (this.imgTransform && this.currentItem.mediaType === 'image') {
        transform = this.imgTransform;
      } // all rotate


      if (this.viewRotate) {
        transform += " rotate(".concat(this.viewRotate, "deg)");
      }

      if (transform) {
        styleObj.transform = transform;
      }

      return styleObj;
    },
    videoRatio: function videoRatio() {
      var ratio = 1.77778;
      var currentItem = this.currentItem,
          video = this.video;

      if (currentItem && currentItem.ratio) {
        ratio = currentItem.ratio;
      } else if (video && video.ratio) {
        ratio = video.ratio;
      }

      return ratio;
    },
    iframeStyles: function iframeStyles() {
      var styleObj = this.$_getItemSizes(this.iframe);
      return Object.assign({}, this.iframe, styleObj);
    },
    videoStyles: function videoStyles() {
      var styleObj = this.$_getItemSizes(this.video);
      var _this$aspectRatio = this.aspectRatio,
          width = _this$aspectRatio.width,
          height = _this$aspectRatio.height;
      if (!styleObj.width) styleObj['width'] = width;
      if (!styleObj.height) styleObj['height'] = height;
      return styleObj;
    },
    innerStyles: function innerStyles() {
      return {
        'padding-bottom': this.paddingBottom + 'px'
      };
    },
    // Lightbox classes
    lightboxClasses: function lightboxClasses() {
      var classesReturn = [{
        'is-can-zoom': this.canZoom && !this.disableZoom
      }, {
        'is-zooming': this.isZooming
      }, {
        'is-thumbs-show': this.showThumbs
      }, {
        'is-swipping': this.isDraggingSwipe
      }, {
        'theme-light': this.theme === 'light'
      }];

      var _ref = document.body || document.documentElement,
          clientWidth = _ref.clientWidth,
          clientHeight = _ref.clientHeight;

      var galleryPosition = this.galleryPosition ? this.galleryPosition : clientHeight > clientWidth ? 'bottom' : 'right';
      var classString = 'cool-lightbox--thumbs-' + galleryPosition;
      classesReturn.push(classString);
      return classesReturn;
    },
    // Buttons classes
    buttonsClasses: function buttonsClasses() {
      return {
        'hidden': !this.buttonsVisible
      };
    },
    // check if the slide has next element
    hasNextButton: function hasNextButton() {
      return this.imgIndex + 1 < this.items.length;
    },
    // check if the slide has previous element 
    hasPreviousButton: function hasPreviousButton() {
      return this.imgIndex - 1 >= 0;
    },
    // check if the slide has next element
    hasNext: function hasNext() {
      return this.imgIndex + 1 < this.items.length;
    },
    // check if the slide has previous element
    hasPrevious: function hasPrevious() {
      return this.imgIndex - 1 >= 0;
    },
    toolbarList: function toolbarList() {
      var toolbar = this.toolbar,
          currentItem = this.currentItem,
          items = this.items;

      if (toolbar && toolbar.length > 1) {
        if (isMobile) {
          return toolbar.filter(function (tool) {
            return tool !== 'fullscreen' && tool !== 'download';
          });
        }

        return toolbar;
      }

      if (items.length === 1) {
        if (currentItem.mediaType === 'image') {
          return ['zoom', 'rotate', 'close'];
        } else if (currentItem.mediaType === 'video') {
          return ['rotate', 'close'];
        } else {
          return ['close'];
        }
      } else {
        if (isMobile) {
          return ['counter', 'zoom', 'slide', 'rotate', 'gallery', 'close'];
        }

        return ['counter', 'zoom', 'slide', 'rotate', 'gallery', 'fullscreen', 'download', 'close'];
      }
    },
    disableZoom: function disableZoom() {
      return !this.toolbarList.includes('zoom');
    }
  },
  watch: {
    zoomBarSize: function zoomBarSize(val, prev) {
      if (this.isZooming) {
        var newZoom = 1.6 + val / 10;
        this.imgTransform = "translate3d(calc(-50% + ".concat(this.left, "px), calc(-50% + ").concat(this.top, "px), 0px) scale3d(").concat(newZoom, ", ").concat(newZoom, ", ").concat(newZoom, ")");
      }
    },
    index: function index(val, prev) {
      // 加入`isVisible`判断，防止外界更改index后重新初始化
      if (isNumber(val) && !this.isVisible) {
        this.$_initial(val);
      }
    },
    imgIndex: {
      immediate: true,
      handler: function handler(val, prev) {
        if (val !== this.index) {
          this.$emit('update:index', val);
        } // 切换预览


        if (val !== null) {
          // 重置loading
          this.changeLoading(false); // loading

          this.changeLoading(true); // add caption padding to Lightbox wrapper

          this.$_addCaptionPadding(); // set video aspect ratio

          if (['webVideo', 'video'].includes(this.currentItem.mediaType)) {
            this.$_setAspectRatio(this.videoRatio);
          }
        } // reset zoom


        this.resetZoom(); // reset swipe type

        this.swipeType = null;
      }
    }
  },
  mounted: function mounted() {
    // set container
    this.$_setParentEl();

    if (!this.$parentEl) {
      throw Error('container is not valid HTMLElement!');
    } // Insert $el


    this.$parentEl.appendChild(this.$el);

    if (isNumber(this.index)) {
      this.$_initial(this.index);
      addFullscreenListener.call(this, this.fullScreenListener);
      this.$once('hook:beforeDestroy', removeFullscreenListener.bind(this, this.fullScreenListener));
    }
  },
  destroyed: function destroyed() {
    if (this.enableScrollLock) {
      this.$_disableBodyLock();
    } // remove lightbox element


    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }

    if (this.$parentEl) this.$parentEl = null;
  },
  methods: {
    $_enableBodyLock: function $_enableBodyLock() {
      document.body.classList.add('compensate-for-scrollbar');
    },
    $_disableBodyLock: function $_disableBodyLock() {
      document.body.classList.remove('compensate-for-scrollbar');
    },
    $_setParentEl: function $_setParentEl() {
      var container = this.container;

      if (container instanceof HTMLElement) {
        this.$parentEl = container;
      } else if (typeof container === 'string') {
        this.$parentEl = document.querySelector(container);
      }
    },
    $_getItemSizes: function $_getItemSizes(obj) {
      var styleObj = {};
      var _this$currentItem2 = this.currentItem,
          width = _this$currentItem2.width,
          height = _this$currentItem2.height,
          maxWidth = _this$currentItem2.maxWidth,
          maxHeight = _this$currentItem2.maxHeight;

      if (isObject(obj)) {
        width = width || obj.width;
        height = height || obj.height;
        maxWidth = maxWidth || obj.maxWidth;
        maxHeight = maxHeight || obj.maxHeight;
      }

      width && (styleObj.width = cssUnit(width));
      height && (styleObj.height = cssUnit(height));
      maxWidth && (styleObj['max-width'] = cssUnit(maxWidth));
      maxHeight && (styleObj['max-height'] = cssUnit(maxHeight));
      return styleObj;
    },
    $_setAspectRatio: function $_setAspectRatio(ratio) {
      var _this = this;

      this.$nextTick(function () {
        var $el = _this.$refs['content'];

        if ($el) {
          var _$el$getBoundingClien = $el.getBoundingClientRect(),
              width = _$el$getBoundingClien.width,
              height = _$el$getBoundingClien.height;

          if (width / height > ratio) {
            _this.aspectRatio = {
              width: "".concat(Math.floor(height * ratio), "px"),
              height: "".concat(Math.floor(height), "px")
            };
          } else {
            _this.aspectRatio = {
              width: "".concat(Math.floor(width), "px"),
              height: "".concat(Math.floor(width / ratio), "px")
            };
          }
        }
      });
    },
    toggleFullScreenMode: function toggleFullScreenMode() {
      if (this.isFullScreenMode) {
        closeFullscreen();
      } else {
        fullScreenMode();
      }
    },
    fullScreenListener: function fullScreenListener() {
      this.isFullScreenMode = !this.isFullScreenMode;
    },
    onRotate: function onRotate(dir) {
      if (dir === 'left') {
        this.viewRotate += -90;
      } else if (dir === 'right') {
        this.viewRotate += 90;
      }
    },
    onDownload: function onDownload() {
      console.log('download');
    },
    // check if event is arrow button or toolbar button
    $_checkOutOfSwipe: function $_checkOutOfSwipe(event) {
      if (event.type.includes('mouse')) {
        var elements = ['.cool-lightbox-video video', '.cool-lightbox-video iframe', '.cool-lightbox-iframe iframe'];
        return matchesDom(event.target, elements, event.currentTarget);
      }

      return false;
    },
    // start swipe event
    startSwipe: function startSwipe(event) {
      if (this.isZooming) {
        return false;
      } // check if is some button


      if (this.$_checkOutOfSwipe(event)) {
        return false;
      } // starts swipe


      this.isDraggingSwipe = true;
      this.initialMouseX = this.$_getMouseXPosFromEvent(event);
      this.initialMouseY = this.$_getMouseYPosFromEvent(event);
    },
    // continue swipe event
    continueSwipe: function continueSwipe(event) {
      if (this.isDraggingSwipe) {
        this.IsSwipping = true;
        var currentPosX = this.$_getMouseXPosFromEvent(event);
        var currentPosY = this.$_getMouseYPosFromEvent(event); // const windowWidth = this.lightboxInnerWidth
        // diffs

        var diffX = Math.abs(currentPosX - this.initialMouseX);
        var diffY = Math.abs(currentPosY - this.initialMouseY); // swipe type

        if (this.swipeType == null) {
          if (diffY > 5 || diffX > 5) {
            if (diffY > diffX) {
              this.swipeType = 'v';
            } else {
              this.swipeType = 'h';
            }
          }
        } // mobile caseS


        if (event.type === 'touchmove') {
          this.endMouseX = this.$_getMouseXPosFromEvent(event);
          this.endMouseY = this.$_getMouseYPosFromEvent(event);
        }
      }
    },
    // end swipe event
    endSwipe: function endSwipe(event) {
      var _this2 = this;

      if (this.$_checkOutOfSwipe(event) && this.initialMouseX === 0) {
        return false;
      } // event check is dragging and swipe


      var swipeType = this.swipeType;
      this.isDraggingSwipe = false; // horizontal swipe type

      if (this.initialMouseX === 0 && swipeType == 'h') {
        return false;
      } // touch end fixes


      if (event.type !== 'touchend') {
        this.endMouseX = this.$_getMouseXPosFromEvent(event);
        this.endMouseY = this.$_getMouseYPosFromEvent(event);
      } else {
        if (this.endMouseX === 0) {
          return;
        }
      } // check if is dragged


      if (this.endMouseX - this.initialMouseX === 0 && swipeType === 'h' || this.isZooming || this.endMouseY - this.initialMouseY === 0 && swipeType === 'v') {
        return;
      } // reset swipe data


      setTimeout(function () {
        _this2.IsSwipping = false;
        _this2.initialMouseX = 0;
        _this2.endMouseX = 0;
      }, 10); // type of swipe

      if (this.swipeType === 'h') {
        // if the swipe is to the right
        if (this.endMouseX - this.initialMouseX < -40) {
          return this.changeIndexToNext();
        } // if the swipe is to the left


        if (this.endMouseX - this.initialMouseX > 40) {
          return this.changeIndexToPrev();
        }
      }

      if (this.swipeType === 'v') {
        var diffY = Math.abs(this.endMouseY - this.initialMouseY); // diff Y

        if (diffY >= 90) this.close();
      }

      this.swipeType = null;
    },
    // function that return x position from event
    $_getMouseXPosFromEvent: function $_getMouseXPosFromEvent(event) {
      if (event.type.indexOf('mouse') !== -1) {
        return event.clientX;
      }

      return event.touches[0].clientX;
    },
    // function that return Y position from event
    $_getMouseYPosFromEvent: function $_getMouseYPosFromEvent(event) {
      if (event.type.indexOf('mouse') !== -1) {
        return event.clientY;
      }

      return event.touches[0].clientY;
    },
    // toggle play slideshow event
    toggleSlide: function toggleSlide() {
      if (!this.toolbarList.includes('slide')) {
        return false;
      }

      if (!this.hasNext && !this.loopData) {
        return false;
      }

      this.isPlayingSlideShow = !this.isPlayingSlideShow; // if is playing move if not stop it

      if (this.isPlayingSlideShow) {
        this.move();
      } else {
        this.stopSlideShow();
      }
    },
    // stop slideshow
    stopSlideShow: function stopSlideShow() {
      this.isPlayingSlideShow = false;
      clearInterval(this.intervalProgress);
      this.stylesInterval = {
        'transform': 'scaleX(0)',
        'transition': 'none'
      };
    },
    // move event in zoom
    move: function move() {
      var self = this;
      this.progressWidth = 100;
      this.intervalProgress = setInterval(frame, this.slideDuration + 90);
      this.stylesInterval = {
        'transform': 'scaleX(1)',
        'background': this.highColor,
        'transition-duration': this.slideDuration + 'ms'
      };

      function frame() {
        self.stylesInterval = {
          'transform': 'scaleX(0)',
          'transition': 'none'
        };
        self.next(true);

        if (!self.hasNext && !self.loopData) {
          self.stopSlideShow();
        } else {
          setTimeout(function () {
            self.stylesInterval = {
              'transform': 'scaleX(1)',
              'background': self.highColor,
              'transition-duration': self.slideDuration + 'ms'
            };
          }, 50);
        }
      }
    },
    // check if is allowed to drag
    $_checkMouseEventPropButton: function $_checkMouseEventPropButton(button) {
      if (!this.isZooming) return false; // mouse left btn click

      return button === 0;
    },
    // handle mouse down event
    handleMouseDown: function handleMouseDown(e) {
      if (!this.$_checkMouseEventPropButton(e.button)) return;
      this.lastX = e.clientX;
      this.lastY = e.clientY;
      this.isDraging = true;
      e.stopPropagation();
    },
    // handle mouse up event
    handleMouseUp: function handleMouseUp(e) {
      if (!this.$_checkMouseEventPropButton(e.button)) return;
      this.isDraging = false;
      this.lastX = this.lastY = 0; // Fix drag zoom out

      var thisContext = this;
      setTimeout(function () {
        thisContext.canZoom = true;
      }, 100);
    },
    // handle mouse move event
    handleMouseMove: function handleMouseMove(e) {
      if (!this.$_checkMouseEventPropButton(e.button)) return;

      if (this.isDraging) {
        this.top = this.top - this.lastY + e.clientY;
        this.left = this.left - this.lastX + e.clientX;
        this.lastX = e.clientX;
        this.lastY = e.clientY;
        this.canZoom = false;
        var newZoom = 1.6 + this.zoomBarSize / 10;
        this.imgTransform = "translate3d(calc(-50% + ".concat(this.left, "px), calc(-50% + ").concat(this.top, "px), 0px) scale3d(").concat(newZoom, ", ").concat(newZoom, ", ").concat(newZoom, ")");
      }

      e.stopPropagation();
    },
    // zoom image event
    zoomImage: function zoomImage() {
      var _this3 = this;

      if (this.disableZoom) return false;
      if (window.innerWidth < 700) return false;
      if (!this.canZoom) return false;
      if (this.IsSwipping) return false; // item zoom
      // zoom variables

      var isZooming = this.isZooming; // Is zooming check

      if (isZooming) {
        if (!this.isDraging) {
          this.isZooming = false;
          this.zoomBarSize = 0;
        }
      } else {
        this.isZooming = true;
      } // check if is zooming


      if (this.isZooming) {
        this.stopSlideShow(); // add scale

        this.imgTransform = 'translate3d(calc(-50%), calc(-50%), 0px) scale3d(1.6, 1.6, 1.6)'; // hide buttons

        this.buttonsVisible = false; // fix drag transition problems

        setTimeout(function () {
          _this3.viewTransition = 'all 0s ease';
        }, 10);
      } else {
        // show buttons
        this.buttonsVisible = true;
        this.resetZoom();
      }
    },
    // Reset zoom data
    resetZoom: function resetZoom() {
      var _this4 = this;

      this.scale = 1;
      this.left = 0;
      this.top = 0;
      this.zoomBarSize = 0;
      this.isZooming = false;
      this.swipeType = null;
      this.viewTransition = 'all .3s ease'; // `this.$nextTick` is to fix imageZoom transition problems

      this.$nextTick(function () {
        // only if index is not null
        if (_this4.imgIndex != null) {
          // reset styles
          if (_this4.disableZoom) {
            _this4.imgTransform = "translate3d(calc(-50% + ".concat(_this4.left, "px), calc(-50% + ").concat(_this4.top, "px), 0px)");
          } else {
            _this4.imgTransform = "translate3d(calc(-50% + ".concat(_this4.left, "px), calc(-50% + ").concat(_this4.top, "px), 0px) scale3d(1, 1, 1)");
          }

          _this4.initialMouseX = 0;

          if (window.innerWidth >= 700) {
            _this4.buttonsVisible = true;
          }
        }
      });
    },
    resetRotate: function resetRotate() {
      var _this5 = this;

      if (this.viewRotate) {
        this.viewTransition = 'all 0s ease';
        this.viewRotate = 0;
        setTimeout(function () {
          _this5.viewTransition = 'all .3s ease';
        }, 100);
      }
    },
    $_wheelEvent: function $_wheelEvent(event) {
      var delay = 350;
      var currentTime = new Date().getTime();
      var direction = event.deltaY > 0 ? 'top' : 'down';
      if (currentTime - this.prevTime < delay) return;
      this.prevTime = currentTime;

      switch (direction) {
        case 'top':
          this.changeIndexToPrev();
          break;

        case 'down':
          this.changeIndexToNext();
          break;
      }
    },
    // caption size
    $_addCaptionPadding: function $_addCaptionPadding() {
      var _this6 = this;

      this.$nextTick(function () {
        if (_this6.currentItem.title || _this6.currentItem.descripcion) {
          var el = _this6.$el.querySelector('.cool-lightbox-caption');

          if (el) {
            _this6.paddingBottom = el.offsetHeight;
          }
        } else {
          _this6.paddingBottom = 0;
        }
      });
    },
    // =======================================================================================
    $_initial: function $_initial(index) {
      var _this7 = this;

      // swipe type
      this.swipeType = null;
      this.initialMouseY = 0;
      this.isVisible = true;
      this.imgIndex = index; // add events listener

      window.addEventListener('keydown', this.$_eventListener); // add wheel event

      if (this.enableWheelEvent) {
        window.addEventListener('wheel', this.$_wheelEvent);
      }

      this.$nextTick(function () {
        if (_this7.enableScrollLock) {
          // lock body
          _this7.$_enableBodyLock();
        }

        _this7.$emit('open', _this7.imgIndex);
      });
    },
    open: function open(index) {
      if (this.isVisible && isNumber(this.imgIndex)) {
        if (index !== this.imgIndex) {
          this.change(index);
        }
      } else {
        this.$_initial(index);
      }
    },
    // close event
    close: function close() {
      // hide and stop slideshow
      this.isVisible = false;
      this.imgIndex = null;
      this.stopSlideShow();
      this.resetRotate();
      this.resetZoom(); // this.showThumbs = false
      // set starts X to 0

      this.startsX = 0;
      this.initialMouseY = 0; // reset swipe type

      this.swipeType = null; // finish swipe

      this.isDraggingSwipe = false;
      this.isZooming = true; // remove events listener

      window.removeEventListener('keydown', this.$_eventListener); // remove body locked

      if (this.enableScrollLock) {
        this.$_disableBodyLock();
      } // remove wheel event


      if (this.enableWheelEvent) {
        window.removeEventListener('wheel', this.$_wheelEvent);
      }

      this.$emit('close');
    },
    closeModal: function closeModal(event) {
      if (!this.clickOutsideHide) return false; // 加载中

      if (this.itemLoading) return false;
      if (this.IsSwipping) return false;
      var elements = ['img', 'video', 'iframe', 'picture', 'source', 'svg', 'path']; // 如果点击元素包含 elements，则不关闭
      // 使用`event.currentTarget`，将检测区域缩到最小

      if (!matchesDom(event.target, elements, event.currentTarget)) {
        this.close();
      }
    },
    // next slide event
    next: function next() {
      var isFromSlideshow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isZooming) {
        return false;
      }

      if (!isFromSlideshow) {
        this.stopSlideShow();
      }

      this.changeIndexToNext();
    },
    // prev slide event
    previous: function previous() {
      var isFromSlideshow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isZooming) {
        return false;
      }

      if (!isFromSlideshow) {
        this.stopSlideShow();
      }

      this.changeIndexToPrev();
    },
    // change to next index
    changeIndexToNext: function changeIndexToNext() {
      if (this.hasNext) {
        this.change(this.imgIndex + 1);
      } else {
        // only if has loop prop
        if (this.loopData) {
          this.change(0);
        }
      }
    },
    // change to prev index
    changeIndexToPrev: function changeIndexToPrev() {
      if (this.hasPrevious) {
        this.change(this.imgIndex - 1);
      } else {
        // only if has loop prop
        if (this.loopData) {
          this.change(this.items.length - 1);
        }
      }
    },
    // index change
    change: function change(index) {
      var _this8 = this;

      this.imgIndex = index;
      this.$emit('change', index);
      setTimeout(function () {
        _this8.$emit('change-end', index);
      }, 350);
    },
    $_getItem: function $_getItem(index) {
      try {
        var item = this.items[index];

        if (item) {
          return isObject(item) ? item : {
            src: item
          };
        }

        return {};
      } catch (error) {
        return {};
      }
    },
    $_checkIsVideo: function $_checkIsVideo(index) {
      var item = this.$_getItem(index);
      var mediaType = item.mediaType,
          src = item.src;
      return mediaType ? ['video', 'webVideo'].includes(mediaType) : isVideo(src);
    },
    // get item thumbnail
    getItemThumb: function getItemThumb(index) {
      var item = this.$_getItem(index);
      return getMediaThumb(item);
    },
    // arrows and escape events
    $_eventListener: function $_eventListener(e) {
      switch (e.keyCode) {
        case 39:
          return this.next();

        case 37:
          return this.previous();

        case 38:
        case 40:
        case ' ':
          return e.preventDefault();

        case 27:
          return this.close();
      }
    },
    changeLoading: function changeLoading(val) {
      this.itemLoading = val;
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: "cool-lightbox-modal"
    }
  }, [_vm.isVisible ? _c("div", {
    class: ["cool-lightbox"].concat(_vm.lightboxClasses, [_vm.customClass]),
    style: {
      "z-index": _vm.zIndex
    },
    attrs: {
      id: _vm.viewerId
    }
  }, [_c("div", {
    staticClass: "cool-lightbox-mask",
    style: {
      "background-color": _vm.overlayColor
    }
  }), _vm._v(" "), _vm.toolbarList.includes("gallery") && _vm.items.length > 1 ? _c("div", {
    staticClass: "cool-lightbox-thumbs",
    style: {
      color: _vm.highColor
    }
  }, [_c("div", {
    staticClass: "cool-lightbox-thumbs__list"
  }, _vm._l(_vm.items, function (item, idx) {
    return _c("i", {
      key: idx,
      class: ["cool-lightbox__thumb", {
        active: idx === _vm.imgIndex
      }, {
        "is-video": _vm.$_checkIsVideo(idx)
      }],
      on: {
        click: function click($event) {
          _vm.imgIndex = idx;
        }
      }
    }, [_c("img", {
      attrs: {
        src: _vm.getItemThumb(idx),
        loading: "lazy",
        alt: ""
      }
    })]);
  }), 0)]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "cool-lightbox-inner",
    style: _vm.innerStyles
  }, [_c("div", {
    staticClass: "cool-lightbox-progressbar",
    style: _vm.stylesInterval
  }), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.itemLoading,
      expression: "itemLoading"
    }],
    staticClass: "cool-lightbox-loading-wrapper"
  }, [_vm._t("loading", function () {
    return [_c("div", {
      staticClass: "cool-lightbox-loading"
    })];
  })], 2), _vm._v(" "), _c("div", {
    ref: "content",
    staticClass: "cool-lightbox-main",
    on: {
      mousedown: function mousedown($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.startSwipe.apply(null, arguments);
      },
      mousemove: function mousemove($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.continueSwipe.apply(null, arguments);
      },
      mouseup: function mouseup($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.endSwipe.apply(null, arguments);
      },
      touchstart: function touchstart($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.startSwipe.apply(null, arguments);
      },
      touchmove: function touchmove($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.continueSwipe.apply(null, arguments);
      },
      touchend: function touchend($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.endSwipe.apply(null, arguments);
      },
      click: function click($event) {
        $event.stopPropagation();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  }, [_c("div", {
    ref: "items",
    staticClass: "cool-lightbox-slide"
  }, [_vm.currentItem.mediaType === "image" ? _c("div", {
    key: "image",
    ref: "imgItem",
    staticClass: "cool-lightbox-image",
    style: _vm.mediaWrapStyle
  }, [_c("transition", {
    attrs: {
      name: "cool-lightbox-slide-change",
      mode: "out-in"
    }
  }, [_c("img", {
    directives: [{
      name: "load",
      rawName: "v-load:image",
      arg: "image"
    }],
    key: _vm.imgIndex,
    attrs: {
      "data-src": _vm.currentItem.src,
      srcset: _vm.currentItem.srcset,
      sizes: _vm.currentItem.sizes,
      alt: _vm.currentItem.alt,
      draggable: "false"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.zoomImage.apply(null, arguments);
      },
      mousedown: function mousedown($event) {
        return _vm.handleMouseDown($event);
      },
      mouseup: function mouseup($event) {
        return _vm.handleMouseUp($event);
      },
      mousemove: function mousemove($event) {
        return _vm.handleMouseMove($event);
      }
    }
  })])], 1) : _vm.currentItem.mediaType === "iframe" ? _c("div", {
    key: "iframe",
    ref: "iframeItem",
    staticClass: "cool-lightbox-iframe",
    style: Object.assign({}, _vm.mediaWrapStyle, _vm.iframeStyles)
  }, [_c("transition", {
    attrs: {
      name: "cool-lightbox-slide-change",
      mode: "out-in"
    }
  }, [_c("iframe", {
    directives: [{
      name: "load",
      rawName: "v-load:iframe",
      arg: "iframe"
    }],
    key: _vm.currentItem.src,
    attrs: {
      "data-src": _vm.currentItem.src,
      frameborder: "0",
      allowfullscreen: "",
      mozallowfullscreen: "",
      webkitallowfullscreen: "",
      oallowfullscreen: "",
      msallowfullscreen: ""
    }
  })])], 1) : _c("div", {
    key: "video",
    ref: "videoItem",
    staticClass: "cool-lightbox-video",
    style: Object.assign({}, _vm.mediaWrapStyle, _vm.videoStyles)
  }, [_c("transition", {
    attrs: {
      name: "cool-lightbox-slide-change",
      mode: "out-in"
    }
  }, [_vm.currentItem.mediaType === "webVideo" ? _c("iframe", {
    directives: [{
      name: "load",
      rawName: "v-load:webVideo",
      arg: "webVideo"
    }],
    key: _vm.currentItem.src,
    attrs: {
      "data-src": _vm.currentItem.src,
      "data-autoplay": _vm.video.autoplay,
      frameborder: "0",
      scrolling: "no",
      allowtransparency: "true",
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: "",
      mozallowfullscreen: "",
      webkitallowfullscreen: "",
      oallowfullscreen: "",
      msallowfullscreen: ""
    }
  }) : _c("video", {
    directives: [{
      name: "load",
      rawName: "v-load:video",
      arg: "video"
    }],
    key: _vm.currentItem.src,
    attrs: {
      "data-src": _vm.currentItem.src,
      "data-autoplay": _vm.video.autoplay,
      playsinline: "",
      controls: "",
      controlslist: "nodownload"
    }
  }, [_c("source", {
    attrs: {
      src: _vm.currentItem.src,
      type: _vm.videoSourceType
    }
  }), _vm._v("\n                Sorry, your browser doesn't support embedded videos\n              ")])])], 1)])]), _vm._v(" "), _vm.navigator && _vm.items.length > 1 ? [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasPreviousButton || _vm.loopData,
      expression: "hasPreviousButton || loopData"
    }],
    staticClass: "cool-lightbox-navigation is-prev",
    class: _vm.buttonsClasses,
    attrs: {
      title: "Previous"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.previous.apply(null, arguments);
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: "arrow-left"
    }
  })], 1), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasNextButton || _vm.loopData,
      expression: "hasNextButton || loopData"
    }],
    staticClass: "cool-lightbox-navigation is-next",
    class: _vm.buttonsClasses,
    attrs: {
      title: "Next"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.next(false);
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: "arrow-right"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm.toolbarList.length > 0 ? _c("div", {
    staticClass: "cool-lightbox-toolbar",
    class: _vm.buttonsClasses
  }, [_c("div", {
    staticClass: "cool-lightbox-toolbar__left"
  }, [_vm.toolbarList.includes("counter") ? _c("span", {
    staticClass: "cool-lightbox-toolbar__counter"
  }, [_vm._v(_vm._s(_vm.imgIndex + 1) + " / " + _vm._s(_vm.items.length))]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "cool-lightbox-toolbar__buttons"
  }, [_vm.toolbarList.includes("slide") && _vm.items.length > 1 ? _c("i", {
    staticClass: "icon-btn",
    attrs: {
      title: "Play slideshow"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toggleSlide.apply(null, arguments);
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: !_vm.isPlayingSlideShow ? "play" : "pause"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.toolbarList.includes("rotate") ? [_c("i", {
    staticClass: "icon-btn",
    attrs: {
      title: "rotate-left"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.onRotate("left");
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: "rotate-left"
    }
  })], 1), _vm._v(" "), _c("i", {
    staticClass: "icon-btn",
    attrs: {
      title: "rotate-right"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.onRotate("right");
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: "rotate-right"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm.toolbarList.includes("gallery") && _vm.items.length > 1 ? _c("i", {
    staticClass: "icon-btn",
    attrs: {
      title: "Show thumbnails"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.showThumbs = !_vm.showThumbs;
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: "grid"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.toolbarList.includes("fullscreen") ? _c("i", {
    staticClass: "icon-btn",
    attrs: {
      title: "Fullscreen"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toggleFullScreenMode.apply(null, arguments);
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: _vm.isFullScreenMode ? "offscreen" : "fullscreen"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.toolbarList.includes("download") ? _c("i", {
    staticClass: "icon-btn",
    attrs: {
      title: "download"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.onDownload.apply(null, arguments);
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: "download"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.toolbarList.includes("close") ? _c("i", {
    staticClass: "icon-btn",
    attrs: {
      title: "Close"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c("Icon", {
    attrs: {
      name: "close"
    }
  })], 1) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c("transition", {
    attrs: {
      name: "cool-lightbox-modal"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentItem.title || _vm.currentItem.description,
      expression: "currentItem.title || currentItem.description"
    }],
    key: "caption-block",
    staticClass: "cool-lightbox-caption"
  }, [_c("transition", {
    attrs: {
      name: "cool-lightbox-slide-change",
      mode: "out-in"
    }
  }, [_vm.currentItem.title ? _c("h6", {
    key: "title",
    staticClass: "caption-title",
    domProps: {
      innerHTML: _vm._s(_vm.currentItem.title)
    }
  }) : _vm._e()]), _vm._v(" "), _c("transition", {
    attrs: {
      name: "cool-lightbox-slide-change",
      mode: "out-in"
    }
  }, [_vm.currentItem.description ? _c("div", {
    key: "description",
    staticClass: "caption-description",
    domProps: {
      innerHTML: _vm._s(_vm.currentItem.description)
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c("transition", {
    attrs: {
      name: "cool-lightbox-modal"
    }
  }, [_vm.isZooming ? _c("div", {
    staticClass: "cool-lightbox-zoom"
  }, [_c("Icon", {
    staticClass: "cool-lightbox-zoom__icon",
    attrs: {
      name: "minus"
    }
  }), _vm._v(" "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoomBarSize,
      expression: "zoomBarSize"
    }],
    attrs: {
      type: "range",
      name: "points",
      min: "0",
      max: "50"
    },
    domProps: {
      value: _vm.zoomBarSize
    },
    on: {
      __r: function __r($event) {
        _vm.zoomBarSize = $event.target.value;
      }
    }
  }), _vm._v(" "), _c("Icon", {
    staticClass: "cool-lightbox-zoom__icon",
    attrs: {
      name: "plus"
    }
  })], 1) : _vm._e()])], 2)]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var install = function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('LightBox', __vue_component__);
};

if (typeof window !== 'undefined' && window.Vue) {
  Vue.use(install); // eslint-disable-line
}

__vue_component__.install = install;

export { __vue_component__ as default };
